import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import {
    useStylesLbl,
    useStylesAutoSafe
} from '../../../../St/Reports/UseStyle';
import { sto } from "../../../../Context/InshData";

export default function GardUnitsForm(props) {
    const {
        AutoOptions,
        rptParams,
        onChangeAutoData,
        typeQties,
        typeItems,
        OptionsSafes,
        typeCosts
    } = props;

    const { t } = useTranslation(["forms"]);

    const claslbl = useStylesLbl();
    const clasASafe = useStylesAutoSafe();
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disabled={sto.User_typei === 1 ? false : true}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                InputLabelProps={{ className: claslbl.clrSafe }}
                            />
                        )}

                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.safe}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('safe', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={OptionsSafes}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} 
                        label={t("safe")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrSafe }} />}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.typeCost}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('typeCost', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={typeCosts}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : t(option.name))}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params}
                            label={t("evaluation_method")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrSafe }} />}
                    />


                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.group}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('group', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={AutoOptions.groups}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params}
                            label={t("forms:product-group")}
                            variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrSafe }} />}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.typeQun}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('typeQun', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={typeQties}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : t(option.name))}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} 
                        label={t("sort_by")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrSafe }} />}
                    />


                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={rptParams.typeItem}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('typeItem', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={typeItems}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} 
                        label={t("item_type")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrSafe }} />}
                    />


                </Grid>


            </Grid>
        </React.Fragment>
    );
}
